import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "../actions/api";

let slice = createSlice({
  name: "opticalCarePlan",
  initialState: {
    OPticalCarePlanList: [],
    total: 10 || 0,
    currentPage: 1,
    toPage: null,
    lastPage: null,
    loading: false,
  },
  reducers: {
    fetchedOpticalCarePlanSuccess: (enrollee, action) => {
      enrollee.loading = false;
      enrollee.OPticalCarePlanList = action.payload?.data;
      enrollee.total = Array.isArray(action.payload.data)
        ? action.payload.data.length
        : action.payload.meta?.total || 0;
      enrollee.currentPage = action.payload.meta?.from || 1;
      enrollee.toPage = action.payload.meta?.to || action.payload.length || 10;
      enrollee.lastPage = action.payload.meta?.last_page || 1;
    },

    fetchedOpticalCarePlanStart: (enrollee, action) => {
      enrollee.loading = true;
    },
    fetchedOpticalCarePlanFailed: (enrollee, action) => {
      enrollee.loading = false;
    },
  },
});

const {
  fetchedOpticalCarePlanSuccess,
  fetchedOpticalCarePlanStart,
  fetchedOpticalCarePlanFailed,
} = slice.actions;

export default slice.reducer;
const url = "/v1/admin/optical-care";

export const fetchOpticalCarePlans = (pageItems, page) =>
  apiCallBegan({
    url: `${url}?page_items=${pageItems}&page=${page}`,
    method: "GET",
    onSuccess: fetchedOpticalCarePlanSuccess.type,
    onStart: fetchedOpticalCarePlanStart.type,
    onError: fetchedOpticalCarePlanFailed.type,
  });


 

export const getOpticalCarePlans = (state) => state.entities.enrolleeOpticalCarePlans;

